export const useNestedModifiers = () => {
  return { nestingLevel: 10 }
}
